/**
 * Set the status of a popup in localStorage.
 *
 * `true` means the popup has been dismissed and should not be shown again.
 *
 * `false` means the popup has not yet been dismissed and can be shown.
 */
export const setAsDismissedInStorage = ({
  storage,
  key,
}: {
  storage?: 'localStorage' | 'sessionStorage';
  key: string;
}) => {
  if (typeof window[storage ?? 'localStorage'] !== 'undefined') {
    try {
      if (storage === 'localStorage') {
        localStorage.setItem(key, JSON.stringify(true));
      } else {
        sessionStorage.setItem(key, JSON.stringify(true));
      }
    } catch (error) {
      console.warn(`Failed to write to ${storage ?? 'localStorage'}`, error);
    }
  }
};
